// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import './ProductSimilar.scss';

type Props = {
  products: Array<{
    id: string,
    title: string,
    thumbnail?: string,
    price?: number,
    brand?: string,
    url_slug: string,
    username: string,
  }>,
  loading: boolean,
};

const ProductSimilar = ({ products, loading }: Props) => {
  if (loading) {
    return (
      <div className="product-similar">
        <div className="product-similar-header">
          <h3>
            <span role="img" aria-label="연관상품">
              ✨
            </span>
            AI 추천 연관 상품
          </h3>
          <p>AI가 분석한 이 상품과 연관된 추천 상품들을 확인해보세요</p>
        </div>
        <div className="product-similar-loading">
          <div className="loading-spinner"></div>
          <p>연관 상품을 찾고 있습니다...</p>
        </div>
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="product-similar">
        <div className="product-similar-header">
          <h3>
            <span role="img" aria-label="연관상품">
              ✨
            </span>
            AI 추천 연관 상품
          </h3>
          <p>AI가 분석한 이 상품과 연관된 추천 상품들을 확인해보세요</p>
        </div>
        <div className="product-similar-empty">
          <span role="img" aria-label="검색결과없음">
            🤷‍♂️
          </span>
          <p>연관된 상품을 찾을 수 없습니다</p>
        </div>
      </div>
    );
  }

  return (
    <div className="product-similar">
      <div className="product-similar-header">
        <h3>
          <span role="img" aria-label="연관상품">
            ✨
          </span>
          AI 추천 연관 상품
        </h3>
        <p>AI가 분석한 이 상품과 연관된 추천 상품들을 확인해보세요</p>
      </div>

      <div className="product-similar-grid">
        {products.map(product => (
          <Link
            key={product.id}
            to={`/@${product.username}/products/${product.url_slug}`}
            className="product-similar-card"
          >
            <div className="product-similar-image">
              {product.thumbnail ? (
                <img src={product.thumbnail} alt={product.title} />
              ) : (
                <div className="product-similar-placeholder">
                  <span role="img" aria-label="상품이미지">
                    📦
                  </span>
                </div>
              )}
            </div>

            <div className="product-similar-content">
              {product.brand && <p className="product-similar-brand">{product.brand}</p>}
              <h4 className="product-similar-title">{product.title}</h4>
              {product.price && product.price > 0 ? (
                <p className="product-similar-price">{product.price.toLocaleString()}원</p>
              ) : (
                ''
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ProductSimilar;



// WEBPACK FOOTER //
// ./src/components/product/ProductSimilar/ProductSimilar.js